import { LogUser } from "core/services/user-activity-logging.service";

export type FilterProps = {
    state: any;
    users: LogUser[] | null;
    handleChange: any;
    isLoading: boolean;
    download: any;
}

export const useHandleChange = (handleChange: any, autoUpdate = true) => {
    const handleSelectChange = (option?: any, name?: string) => handleChange(name, option.value, "", autoUpdate);

    const handleEventChange = (id: string, newValue: any) => handleChange(id, newValue, "", autoUpdate);

    return { handleSelectChange, handleEventChange };
}

export const getOptions = (users: LogUser[]) => {
    return [
        { label: "All", value: "" },
        ...users.map(x => { return { label: x.name, value: x.id }; })
    ];
}
